<!--
   Created by qing on 2020/12/29
   Des:
-->
<template>
  <div class="ry-home-config__container ry-home-config__view">

    <grid-layout
      class="ry-home-config__chart-container"
      :layout.sync="HomeConfig.configList"
      :col-num="60"
      :row-height="20"
      :is-draggable="false"
      :is-resizable="false"
      :is-mirrored="false"
      :vertical-compact="true"
      :margin="[12, 12]"
      :use-css-transforms="true">

      <grid-item
        class="ry-home-config__chart-item"
        v-for="item in HomeConfig.configList"
        :style="{zIndex: 1}"
        :x="item.x"
        :y="item.y"
        :w="item.w"
        :h="item.h"
        :i="item.i"
        :minW="item.minW"
        :minH="item.minH"
        :maxH="item.maxH"
        :maxW="item.maxW"
        :key="item.configId"
        @mouseenter.native="chartItemMouseenter(item)"
        @mouseleave.native="chartItemMouseleave(item)">

        <component
          :is="'control_' + item.configType"
          :type="CONFIG_STATUS_TYPE__VIEW"
          :value="item"
          :isPhone="true">
        </component>

      </grid-item>

    </grid-layout>
  </div>
</template>

<script>
  import control from '../control/index'
  import RyHomeConfig from "../index"
  import {CONFIG_STATUS_TYPE__VIEW, CONFIG_TYPE__CONTACT_ME, CONFIG_TYPE__DASHBOARD} from "../type";
  import {iconList, arrayRandomElement} from "../../../assets/js/Untis";
  import VueGridLayout from 'vue-grid-layout'

  export default {
    props: {
      customId: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        CONFIG_STATUS_TYPE__VIEW,
        HomeConfig: RyHomeConfig.init({
          userId: this.$store.getters.userId,
          companyId: this.companyId ? this.companyId : this.$store.getters.currentCompanyId,
          customId: this.customId
        })
      }
    },
    components: {
      ...control,
      GridLayout: VueGridLayout.GridLayout,
      GridItem: VueGridLayout.GridItem
    },
    created() {
      this.homeConfigInit()
    },
    methods: {

      // 鼠标进入单个图表元素
      chartItemMouseenter(item) {
      },
      // 鼠标离开 单个图表元素
      chartItemMouseleave(item) {
      },
      homeConfigInit() {
        this.HomeConfig.isInit = false
        if (this.customId && this.customId !== 'default') {

          this.$store.dispatch('actionCustomHomeDetail', {
            customId: this.customId
          }).then(res => {
			  // 临时处理新增的组件不展示 2022年6月27日byzb
			  let newConfigList = [];
			  res.configList.forEach(item => {
				  if((item.configType != 'USERINFO') && (item.configType != 'MESSAGE')){
					  if(item.configType  == 'TODO'){
						  item.width == 60;
					  }
					  newConfigList.push(item);
				  }
			  })
			res.configList = newConfigList;
            this.HomeConfig.setConf(res)
            this.handleSize()
            this.HomeConfig.isInit = true
            this.HomeConfig.getConfigValue()
          }).catch(console.error)

        } else {
          this.$store.dispatch('getApps')
            .then(res => {
              console.log('getApps',res)
              const homeConfig = {
                userId: this.$store.getters.userId,
                companyId: this.$store.getters.currentCompanyId,
                customId: "5ff2c297e4b026bd622d64a9",
                pageName: "1231q",
                matchMember: {
                  depart: [],
                  member: [],
                  role: [],
                  external: [],
                  externalTag: []
                },
                configType: "COMPANY",
                pageDes: "",
                sortIndex: 1,
                status: 1,
                configList: [
                  {
                    configType: "TODO",
                    configName: "",
                    configId: "CONFIGkjmttm2ruZm7W35s",
                    offsetX: 0,
                    offsetY: 0,
                    width: 12,
                    height: 8,
                    showType: "NARROW"
                  },
                  {
                    "configType": "CONTACT_ME",
                    "configName": "",
                    "configId": "CONFIGkjo7om71EP5tjiGz",
                    "offsetX": 0,
                    "offsetY": 8,
                    "width": 12,
                    "height": 9
                  },
                  {
                    configType: "APPS",
                    configName: "常用应用",
                    configId: "CONFIGkjmttnxmBEufWLDH",
                    offsetX: 12,
                    offsetY: 0,
                    width: 48,
                    height: 17,
                    showType: 'WIDE',
                    selectAppIds: res.allAppList.map(app => app.appId)
                  }
                ]
              }
              this.HomeConfig.setConf(homeConfig)
              this.handleSize()
              this.HomeConfig.isInit = true
              this.HomeConfig.getConfigValue()
          }).catch(console.error)
        }
      },
      handleSize() {

        const notExist = this.HomeConfig.configList.some(chart => ![CONFIG_TYPE__CONTACT_ME].includes(chart.configType) && !chart.hasOwnProperty('pY'))
        if (notExist) {
          this.HomeConfig.configList.forEach((chart, idx) => {
            chart.pX = 0
            chart.pW = 60
            chart.pH = 8
            chart.pMinW = 20
            chart.pMinH = 4
            chart.pMaxW = 60
            chart.pMaxH = 1000

            if (idx === 0) {
              chart.pY = 0
            } else {
              const lastChart = this.HomeConfig.configList[idx - 1]
              chart.pY = lastChart.pY + lastChart.pH
            }
          })
        }
        this.HomeConfig.configList.forEach((chart, idx) => {
          if ([CONFIG_TYPE__CONTACT_ME].includes(chart.configType)) {
            chart.x = 0
            chart.w = 0
            chart.h = 0
            chart.minW = 0
            chart.minH = 0
            chart.maxW = 0
            chart.maxH = 0
            chart.y = 0
          } else {
            chart.x = chart.pX
            chart.w = chart.pW
            chart.h = chart.pH
            chart.minW = chart.pMinW
            chart.minH = chart.pMinH
            chart.maxW = chart.pMaxW
            chart.maxH = chart.pMaxH
            chart.y = chart.pY
          }
        })

        for (let i = this.HomeConfig.configList.length - 1; i >= 0 ; i--) {
          const config = this.HomeConfig.configList[i]
          if (config.hidden) {
            this.HomeConfig.configList.splice(i, 1)
          }
        }
      }
    }
  }
</script>

<style lang="less">

  .ry-home-config__chart-container {
    min-height: 100%;
    overflow: hidden;
    width: 100%;

    .ry-home-config__chart-item {
      border-radius: 10px;
      background-color: #fff;

      &:hover {

      }
    }

    .vue-grid-item.vue-grid-placeholder {
      background: #2D8cF0;
    }

    .vue-grid-item > .vue-resizable-handle {
      z-index: 3;
    }
  }
</style>
